import { organizationHeader } from '@cast/constants';

export function overrideOrganizationHeader(
  organizationId: string | undefined
): Record<string, string | undefined> {
  return {
    [organizationHeader]: organizationId,
  };
}
